<div [@routerTransition]>
    <section class="container p-5">
        <h1 class="mb-10 title">Política de Privacidade</h1>
        <div class="mb-10 text" [innerHTML]="privacyPolicy | sanitizeHtml"></div>
    </section>
</div>

